module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"head_office":"Head office","industry":"Industry","category_code":"Category code","closing":"Deadline","svg":{"alia-label":{"like":"Like Icon"},"title":{"like":"Like"},"desc":{"like":"Like Icon"}}}}')
  delete Component.options._Ctor
}
